
import { Route, Routes } from 'react-router-dom';
import { StoryForm } from './story/StoryForm';
import { StoryList } from './story/StoryListByTopic';
import { PrivateRoute } from '../components/PrivateRoute';
import { StoryModify } from './story/StoryModify';
import useQueryString from '../../utils/hooks/useQueryString';

/**
 * 선택한 주제 및 글 목록을 처리 한다
 * @returns 
 */
export const TopicView = () => {
    const { bestYn } = useQueryString();

    return (
        <div className={`topicPage ${bestYn === "Y" ? "bestStoryPage" : ""}`}>
            <div className="inner">
                <Routes>
                    <Route path="/" element={<StoryList />} />
                    <Route path="/form" element={<PrivateRoute> <StoryForm useTemp={true} /> </PrivateRoute>} />
                    <Route path="/edit/:storyId" element={<PrivateRoute> <StoryModify /> </PrivateRoute>} />
                </Routes>
            </div>
        </div>
    );
};